import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isSunroof: false, // Default: no sunroof
};

export const isSunroofSlice = createSlice({
    name: "isSunroof",
    initialState,
    reducers: {
        setIsSunroof: (state, action) => {
            state.isSunroof = action.payload;
        },
        resetIsSunroof: (state) => {
            state.isSunroof = false;
        },
    },
});

export const { setIsSunroof, resetIsSunroof } = isSunroofSlice.actions;

export default isSunroofSlice.reducer;